import type { AddressResultType, PositionType } from 'app/src/model'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import * as atlas from 'azure-maps-control'

export interface IAbstractAtlasControlOptions {
  onControlClickCallBack?: () => void
  style?: string
}

export function convertFromAtlasPosition(position: atlas.data.Position): PositionType {
  return {
    lat: position[1],
    lon: position[0],
  }
}

export function convertToAtlasPosition(position: companyagreementApi.GeoLocation): atlas.data.Position {
  return new atlas.data.Position(position?.longitude, position?.latitude)
}

export function convertFromGeoLocationToPositionType(position: companyagreementApi.GeoLocation): PositionType {
  return {
    lat: position.latitude,
    lon: position.longitude,
  }
}

export function getGeoDistance(point1: PositionType, point2: PositionType): number {
  const R = 6371e3 // metres
  const phi1 = (point1.lat * Math.PI) / 180 // phi, lambda in radians
  const phi2 = (point2.lon * Math.PI) / 180
  const deltaphi = ((point2.lat - point1.lat) * Math.PI) / 180
  const deltalambda = ((point2.lon - point1.lon) * Math.PI) / 180

  const a =
    Math.sin(deltaphi / 2) * Math.sin(deltaphi / 2) +
    Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltalambda / 2) * Math.sin(deltalambda / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return R * c
}
export function round(num: number, decimalPlaces: number = 0) {
  const p = Math.pow(10, decimalPlaces)
  const n = num * p * (1 + Number.EPSILON)
  return Math.round(n) / p
}

export function getNavigatorPosition(
  successCallBack: (address: AddressResultType) => void,
  errorCallback?: PositionErrorCallback,
) {
  navigator.geolocation.getCurrentPosition(
    (pos) =>
      successCallBack({
        position: {
          lat: pos.coords.latitude,
          lon: pos.coords.longitude,
        },
      }),
    errorCallback,
    {
      enableHighAccuracy: true,
      timeout: 10000,
    },
  )
}
